import { apiRoutes } from 'config/apiRoutes'
import { queryKeys } from 'config/queryKeys'
import { useMutation, useQueryClient } from 'libs/query'
import { useTranslation } from 'react-i18next'
import { useAxiosPrivate, useToast } from 'shared/hooks'

type UseDeleteCategoryMutationProps = {
	id: string | null
	onSettled: () => void
}

export const useDeleteCategoryMutation = ({ id, onSettled }: UseDeleteCategoryMutationProps) => {
	const { t } = useTranslation()
	const queryClient = useQueryClient()
	const axiosPrivate = useAxiosPrivate()

	const { mutate: deleteCategoryMutation } = useMutation({
		mutationFn: () => {
			return axiosPrivate.delete(apiRoutes.category(id!))
		},
		onSuccess: () => {
			useToast({
				type: 'success',
				message: t('Category deleted')
			})()
			queryClient.invalidateQueries({ queryKey: queryKeys.categories.all })
		},
		onError: () => {
			useToast({
				type: 'error',
				message: t('Something went wrong')
			})()
		},
		onSettled: () => {
			onSettled()
		}
	})

	return {
		deleteCategoryMutation
	}
}
